module.exports = __webpack_public_path__ + "static/media/5.acbf1f7b.JPG";